import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../../../Model/Combo/combo.service';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';

@Component({
  selector: 'app-branch-holiday-form',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, ReactiveFormsModule, NgbNavModule, NgSelectModule, RouterModule],
  templateUrl: './branch-holiday-form.component.html',
  styleUrl: './branch-holiday-form.component.scss'
})
export class BranchHolidayFormComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  HolidayData = [] as any;
  HolidayMappingDetail = {
    BranchId: 0,
    ESS_CompanyHolidayMaster: [],
  }

  DisablesFilter = {
    Year:false,
    Branch:false,
  }

  filter = {
    SelectType: 2,
    BranchId: null as any,
    Year: null as any,
    TypesOfLeave: null,
  }

  Branchs = [] as any;
  Years = [] as any;
  TypesOfLeaves = ['NA', 'Compulsory', 'Optional'];
  dtoptions: DataTables.Settings = {};
  constructor(
    private holiday: HolidayService,
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    private utility: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    protected common: CommonService,
    private tooltip : TooltipService
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.filter.BranchId = parseInt(params['id']));
    this.route.params.subscribe(params => this.filter.Year = parseInt(params['year']));
    if (this.filter.BranchId == 0) {
      this.filter.BranchId = null;
      this.filter.Year = null;
    }else{
      this.DisablesFilter = {
        Year:true,
        Branch:true,
      }
    }
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
    if (this.filter.BranchId > 0) {
      this.GetBranchHoliday();
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': null, 'StateId': 0, 'DistrictId': 0, 'EmpMasterID': 0 }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.Branchs = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Validate(form: any) {
    if (form.valid) {
      this.GetBranchHoliday();
    }
    else {
      form.submitted = true;
    }
  }

  GetBranchHoliday() {
    this.isDisabled = true;
    this.holiday.GetBranchHoliday(this.filter).subscribe({
      next: (response) => {
        try {
          this.HolidayData = [];
          this.HolidayMappingDetail.ESS_CompanyHolidayMaster = response.Table;
          this.HolidayData = Object.values(response.Table)

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ClearHolidays() {
    this.HolidayData = Object.values([])
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  async SaveBranchHoliday() {
    await this.common.getPageRights();
    if(this.HolidayMappingDetail.ESS_CompanyHolidayMaster.length > 0){
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = this.HolidayMappingDetail.ESS_CompanyHolidayMaster.filter((e:any) => this.common.ToLowerCase(e.TypesOfLeave) == 'compulsory' || this.common.ToLowerCase(e.TypesOfLeave) == 'optional').length > 0? 'Do you want to save?':'All NA Holiday Type Will be Deleted. Do you want to delete?';
      modalRef.result.then((result: any) => {
        if((this.common.PageRight.IsAdd && this.filter.BranchId == 0) || (this.common.PageRight.IsEdit && this.filter.BranchId > 0)){
          if (result) {
            this.isDisabled = true;
            this.HolidayMappingDetail.BranchId = this.filter.BranchId;
            this.holiday.SaveBranchHoliday(this.HolidayMappingDetail).subscribe({
              next: (response) => {
                if (response.Error_Code == '385') {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.close();
                    }
                  });
                }
                else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        }else{
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }).catch(() => {
        // Modal dismissed
      });
    }else{
      this.toast.show({message:'Please select holidays',type:toastTypeEnum.warning});
    }
    
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  close(){
    this.router.navigate(['/master/holiday/branch']);
  }
}
